var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChrono(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11.906702mm",
    height: "9.6388178mm",
    viewBox: "0 0 11.906702 9.6388178",
    id: "svg1",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-89.302232,-148.33828)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3",
    transform: "matrix(0.75552611,0,0,0.75552611,15.798728,41.040247)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6e3ceb",
      fillOpacity: 0.996078,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 106.08398,142.07031 c -2.50728,-0.29399 -5.47281,0.60856 -7.472652,3.56836 -2.981277,4.41234 0.0059,8.8086 0.0059,8.8086 a 0.76607657,0.76607657 0 0 0 0.628907,0.32812 h 11.636715 a 0.76607657,0.76607657 0 0 0 0.55469,-0.23633 c 0,0 0.75615,-0.79962 1.22266,-2.13867 0.46651,-1.33905 0.66483,-3.28591 -0.30274,-5.55469 a 0.76599997,0.76599997 0 0 0 -1.00586,-0.40429 0.76599997,0.76599997 0 0 0 -0.40429,1.0039 c 0.81788,1.91779 0.63027,3.4045 0.26562,4.45117 -0.30987,0.88945 -0.63202,1.21066 -0.75195,1.34766 H 99.736328 c -0.304519,-0.46462 -2.127035,-3.38609 0.144531,-6.74805 2.254201,-3.33626 5.756851,-3.39866 7.833981,-2.38672 a 0.76599997,0.76599997 0 0 0 1.02344,-0.35351 0.76599997,0.76599997 0 0 0 -0.35156,-1.02344 c -0.68127,-0.3319 -1.46697,-0.56411 -2.30274,-0.66211 z",
    id: "path3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 110.93305,144.2902 -4.57311,6.68364 c -0.30185,0.28713 -0.70715,0.44812 -1.12954,0.44812 -0.21233,0 -0.42259,-0.0408 -0.61877,-0.11989 -0.19616,-0.0793 -0.37443,-0.19523 -0.52455,-0.34153 -0.15015,-0.14631 -0.26929,-0.31996 -0.35053,-0.5111 -0.0813,-0.19117 -0.12309,-0.396 -0.12309,-0.60293 0,-0.41151 0.16527,-0.80646 0.45997,-1.10057 z",
    fill: "url(#paint2_linear_842_4801)",
    stroke: "url(#paint3_linear_842_4801)",
    id: "path2-8",
    style: {
      fill: "#6d3ceb",
      fillOpacity: 0.996078,
      stroke: "none",
      strokeWidth: 0.398755,
      strokeOpacity: 0.996078
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChrono);
export default __webpack_public_path__ + "static/media/chrono.de063e6b40558375b1085890b5f7c390.svg";
export { ForwardRef as ReactComponent };